















import { defineComponent } from '@vue/composition-api';
import Vue from 'vue';

export default defineComponent({
  name: 'FileIcon',
  props: {
    item: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconClass: {
      // icon 样式，默认 smh-icon--32 icon-container
      type: String,
      required: false,
      default: 'smh-icon--32 icon-container',
    },
  },
  setup(props, context) {
    const methods = {
      getDefaultIcon() {
        const FileIcon = Vue.filter('FileIcon');
        return FileIcon(props.item.name, props.item);
      },
      onError(event: any) {
        const img = event.srcElement;
        img.src = require('@/renderer/assets/images/Icon/new-icon/file_image.svg');
        img.classList.remove('image-preview');
        props.iconClass?.split(' ').forEach(cls => {
          img.classList.add(cls);
        });
      },
    };
    return {
      ...methods,
    };
  },
});
